export default class InvoiceHelper {
  static isReadOnly(status) {
    switch (status) {
      case 'enqueued':
      case 'received':
      case 'authorized':
      case 'canceled':
      case 'denied':
      case 'removed':
        return true;
      case 'rejected':
      default:
        return false;
    }
  }
}
